@if (labelKey) {
  @if (!groupBy) {
    <ng-select [items]="optionList" [bindLabel]="labelKey" [bindValue]="inputKey" [(ngModel)]="value" [disabled]="isDisabled" [placeholder]="placeholder" [tabIndex]="tabIndex"
      (change)="emitSelectedValue($event)" [name]="name" [clearOnBackspace]="clearOnBackspace" appendTo="{{ appendTo }}" (open)="onOpen()" (close)="onClose($event)">
    </ng-select>
  }
  @if (groupBy) {
    <ng-select [items]="optionList" [bindLabel]="labelKey" [bindValue]="inputKey" [groupBy]="groupBy" [disabled]="isDisabled" [(ngModel)]="value" [placeholder]="placeholder" [tabIndex]="tabIndex"
      (change)="changeEvent.emit($event)" [name]="name" [clearOnBackspace]="clearOnBackspace" appendTo="{{ appendTo }}" (open)="onOpen()" (close)="onClose($event)">
      <ng-template ng-optgroup-tmp let-item="item">
        {{ item[groupBy] || 'Unnamed group' }}
      </ng-template>
    </ng-select>
  }
}

@if (!labelKey) {
  <ng-select [items]="optionList" [(ngModel)]="value" [placeholder]="placeholder" [tabIndex]="tabIndex" [disabled]="isDisabled" (change)="changeEvent.emit($event)" [name]="name"
    [clearOnBackspace]="clearOnBackspace" (open)="onOpen()" (close)="onClose($event)">
  </ng-select>
}

@if (parentForm && !(isDropDownOpen)) {
  <fn-input-error [position]="'bottom'" [submitted]="parentForm.submitted" [control]="parentForm.form.controls[name]" [tabIndex]="tabIndex">
  </fn-input-error>
}